import React, { useContext, useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import dragContext from "../../DragStore/DragContext";
import { useHistory } from "react-router";
import AjaxLoader from "../../../../app/common/common-components/AjaxLoader";
import Progressbar from "../../common/Progressbar";
import { useStore } from "../../../../app/stores/store";

const PipelineSales = ({ pipelineDD, statusDD, currencySymbol, accessType, status, pipelineState,setStatus,setPipelineState,pipelineName,setPipelineName }) => {
  const [isLoading, setIsLoading] = useState(false);
  const state = useContext(dragContext);
  let history = useHistory();
  const {
    userStore: { userSession },
  } = useStore();

  const handleStatusDDChange = (e) => {
    localStorage.setItem("status",e)
    setStatus(e);
  };
  const handlePipelineChange = (id, pName) => {
    setPipelineState(id);
    setPipelineName(pName);
    localStorage.setItem("pipeline",id)
  };
  // const handleDDChange = (e, name) => {
  //   if (name === "Pipeline") {
  //     setPipelineId(e.newValue);
  //     setPipelineName(e.newText);
  //   }
  // };

  const getAmountFormat = (number) => {
    if (isNaN(number)) return "0";

    var SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];
    var tier = (Math.log10(Math.abs(number)) / 3) | 0;

    // if zero, we don't need a suffix
    if (tier == 0) return number.toFixed(1);

    // get suffix and determine scale
    var suffix = SI_SYMBOL[tier];
    var scale = Math.pow(10, tier * 3);

    // scale the number
    var scaled = number / scale;

    // format number and add suffix
    return scaled.toFixed(1) + suffix;
  };

  const getAllDealAmount = (deals, t) => {
    var totalAmount = 0;
    for (var i = 0; i < deals.length; i++) {
      if (t == "P") {
        totalAmount += isNaN(deals[i].purchaseAmount) ? 0 : deals[i].purchaseAmount;
      } else {
        totalAmount += isNaN(deals[i].grossNettCommision) ? 0 : deals[i].grossNettCommision;
      }
    }
    return totalAmount;
  };

  const getAllDealRedPercentage = (deals) => {
    var totalTasks = 0;
    var completedTasks = 0;
    for (var i = 0; i < deals.length; i++) {
      totalTasks += deals[i].totalTasks;
      completedTasks += deals[i].completedTaskRed;
    }

    if (totalTasks == 0) return 0;
    else return (completedTasks * 100) / totalTasks;
  };
  const getAllDealGreenPercentage = (deals) => {
    var totalTasks = 0;
    var completedTasks = 0;
    for (var i = 0; i < deals.length; i++) {
      totalTasks += deals[i].totalTasks;
      completedTasks += deals[i].completedTaskGreen;
    }

    if (totalTasks == 0) return 0;
    else return (completedTasks * 100) / totalTasks;
  };

  useEffect(() => {
    setIsLoading(true);
    state.setPipelineName(pipelineName);
    state.setPipelineId(pipelineState);
    state.setStatus(status);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    //console.log(state.pipelineData);
  }, [pipelineState, status]);

  if (isLoading) {
    return <AjaxLoader />;
  }
  return (
    <DragDropContext onDragEnd={state.onDragEnd}>
      {/* <div className="row">
        <div className="col-md-12">
        <div className="d-flex  justify-content-between" style={{ flexWrap: "wrap" }}>
            <div className="d-flex flex-wrap">
              <div className="r_menu_icon_div">
                <i className="fa fa-list r_menu_icon color-oms" aria-hidden="true"></i>
              </div>
              <div>
                <h2 className="my-0 pt-1 mx-2">{pipelineName}</h2>
                <p className="">{state?.pipelineDescription}</p>
              </div>
            </div>
            <div className="" style={{ minWidth: "250px" }}>
              <OMSDropdown
                id="pipelinedd"
                options={pipelineDD}
                valueField="value"
                labelField="text"
                value={pipelineId}
                onChange={(e) => handleDDChange(e, "Pipeline")}
              />
            </div>
          </div>
        </div>
      </div> */}
      <div className="row mt-2">
        <div className="col-md-12">
          <div className="d-flex align-items-center">
            <div className="dropdown card-body mx-2">
              <h6 class="dropdown-toggle cursor-pointer card-subtitles" data-toggle="dropdown">
                {`${status == 1 ? userSession?.displayName : "Company"}'s Workspace`}
                {accessType == 1 ? <b class="caret"></b> : null}
              </h6>
              {accessType == 1 ? (
                <ul class="dropdown-menu">
                  {statusDD?.map((curStatus, i) => {
                    return (
                      <li
                        onClick={() => {
                          handleStatusDDChange(curStatus.value);
                        }}
                      >
                        <a>{curStatus.text}</a>
                      </li>
                    );
                  })}
                </ul>
              ) : null}
            </div>
            <div className="dropdown mx-3">
              <span class="dropdown-toggle text-light cursor-pointer" data-toggle="dropdown">
                {" "}
                pipeline: {pipelineName}
                <b class="caret"></b>
              </span>
              <ul class="dropdown-menu">
                {pipelineDD?.map((curElem, i) => {
                  return (
                    <li key={curElem.value} onClick={() => handlePipelineChange(curElem.value, curElem.text)}>
                      <a >{curElem.text}</a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      {state?.isDataLoading ? (
        <AjaxLoader />
      ) : (
        <div className="row mt-2">
          <div className="drag_cards d-flex">
            {state?.pipelineData?.map((curStage, i) => {
              return (
                <div className="card_item mx-2" key={i}>
                  <div className="d-flex p-1 mx-3">
                    <div className="black_circle" style={{ marginLeft: 8 }}>
                      <Progressbar redCounts={getAllDealRedPercentage(curStage.deals)} greenCounts={getAllDealGreenPercentage(curStage.deals)} />
                    </div>
                    <div className="d-flex flex-column mx-2">
                      <span>
                        {" "}
                        <strong>{curStage.stageName}</strong>{" "}
                      </span>
                      <span className="small_caption">
                        {`${curStage.deals.length} Transactions | ${currencySymbol}${getAmountFormat(
                          getAllDealAmount(curStage.deals, "P")
                        )} Sales | ${currencySymbol}
                        ${getAmountFormat(getAllDealAmount(curStage.deals, "G"))} GC
                      `}
                      </span>
                    </div>
                  </div>
                  <Droppable droppableId={curStage.stageId}>
                    {(provided) => (
                      <div className="mt-4 drag_drop_container  p-3" ref={provided.innerRef} {...provided.droppableProps}>
                        {curStage.deals?.map((curElem, i) => {
                          return (
                            <Draggable key={curElem.dealID} draggableId={curElem.dealID} index={i}>
                              {(provided) => (
                                <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef} className="card_element mt-2 p-2">
                                  <div className="d-flex align-items-center">
                                    <div className="" style={{ marginLeft: "3.5px" }}>
                                      <div className="black_circle">
                                        <Progressbar
                                          redCounts={curElem.totalTasks == 0 ? 0 : (curElem.completedTaskRed * 100) / curElem.totalTasks}
                                          greenCounts={curElem.totalTasks == 0 ? 0 : (curElem.completedTaskGreen * 100) / curElem.totalTasks}
                                        />
                                      </div>
                                    </div>
                                    <div className="mx-2 p-2 d-flex flex-column">
                                      <div className="">
                                        <span
                                          className="element_link"
                                          onClick={() => {
                                            history.push(`/deal/saveDeal?ID=${curElem.dealID}`);
                                          }}
                                        >
                                          {curElem.dealName}
                                        </span>
                                      </div>
                                      {curElem.registrationDate ? (
                                        <div className="" style={{ fontSize: "12px", marginTop: 4, marginBottom: 2 }}>
                                          <i className="fa fa-calendar" style={{ fontSize: "12px" }}></i>{" "}
                                          <span>Expected Registration: {curElem.registrationDate}</span>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      <div className="tags ">
                                        <span className="tag1 bg-oms1">{`${currencySymbol} ${getAmountFormat(curElem.purchaseAmount)}`}</span>
                                        <span className="tag2 bg-oms">{`${currencySymbol} ${getAmountFormat(curElem.grossNettCommision)} GC`}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                      </div>
                    )}
                  </Droppable>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </DragDropContext>
  );
};

export default PipelineSales;
